const formatUsd = (v) => v != null ? `$${v.toFixed(2)}` : '--';

const ChartTooltip = ({ data, visible, pos }) => {
  if (!visible || !data) return null;

  return (
    <div
      style={{
        position: 'absolute',
        left: Math.min(pos?.x || 0, (pos?.containerW || 800) - 180),
        top: Math.max((pos?.y || 0) - 120, 0),
        zIndex: 15,
        background: 'rgba(22, 26, 30, 0.95)',
        border: '1px solid #2b3139',
        borderRadius: '6px',
        padding: '8px 12px',
        fontFamily: "'Segoe UI', sans-serif",
        fontSize: '12px',
        color: '#eaecef',
        pointerEvents: 'none',
        minWidth: '140px',
      }}
    >
      <div style={{ color: '#90949a', marginBottom: '4px', fontSize: '11px' }}>
        {data.time ? new Date(data.time * 1000).toLocaleString() : ''}
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '16px' }}>
        <span style={{ color: '#90949a' }}>O:</span>
        <span>{formatUsd(data.open)}</span>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '16px' }}>
        <span style={{ color: '#90949a' }}>H:</span>
        <span style={{ color: '#0ecb81' }}>{formatUsd(data.high)}</span>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '16px' }}>
        <span style={{ color: '#90949a' }}>L:</span>
        <span style={{ color: '#f6465d' }}>{formatUsd(data.low)}</span>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '16px' }}>
        <span style={{ color: '#90949a' }}>C:</span>
        <span>{formatUsd(data.close)}</span>
      </div>
      {data.volume != null && (
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '16px', marginTop: '2px', borderTop: '1px solid #2b3139', paddingTop: '2px' }}>
          <span style={{ color: '#90949a' }}>Vol:</span>
          <span>{(data.volume)}</span>
        </div>
      )}
    </div>
  );
};

export default ChartTooltip;
